export default __webpack_public_path__ + "src/assets/logo-text-blue.b6cdb5fad13e71df18b363cc3c650631.svg";